import styled from "styled-components";
import { useQuery } from "@apollo/client";
import { GET_PROFILE } from "@gql/queries";
import { getAccount } from "wagmi/actions";
import { wagmiConfig } from "@wagmiconfig";
import { getTheme, themed, Flow, Loader, } from "@bracket/ui";
import { AccountInfoHeader } from "./AccountInfoHeader";
import { Form } from "./Form";



export declare type ProfileData = {
	name: string;
	nickname: string;
	email: string;
}



export const Account: React.FC = () => {
	themed();

	const { address } = getAccount(wagmiConfig);
	const {
		data: profileData,
		loading,
		refetch,
	} = useQuery(GET_PROFILE, {
		variables: {
			address: address,
		},
		context: {
			headers: {
				wallet: address,
			},
		},
		skip: !address,
	});

	const userData: ProfileData = {
		name: profileData?.wallet?.user?.name || "",
		nickname: profileData?.wallet?.user?.nickname || "",
		email: profileData?.wallet?.user?.email || "",
	};

	if(loading) {
		return (
			<Container>
				<LoaderContainer>
					<Loader />
				</LoaderContainer>
			</Container>
		);
	}

	return (
		<Container>
			<AccountInfoHeader userData={userData} />
			<Form userData={userData} refetch={refetch} />
		</Container>
	);
};




const Container = styled(Flow)`
	width: 100%;
	background-color: ${() => getTheme().surface};
	color: ${() => getTheme().surface_on};
	border-radius: 0.5rem;
`;

const LoaderContainer = styled(Flow)`
	justify-content: center;
	align-items: flex-start;
	min-height: 200px;
	padding-left: 50px;
`;
